// extracted by mini-css-extract-plugin
module.exports = {"groupContainer":"CardsGroup_groupContainer__Puy_1","root":"CardsGroup_root__948xk","label":"CardsGroup_label__p5JV8"};